import { Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { DosageBreak } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';
import { createDosageBreak } from '../../extendedDosage.utils';

import { DosagePeriodField } from './DosagePeriodField';
import { StyledStagePanel } from './StageField.styled';
import { createStageFieldNameFactory } from './StageFieldList.utils';

const DEFAULTS = createDosageBreak();

type DosageBreakFieldProps = Pick<ExtendedDosageFormController, 'register' | 'watch' | 'trigger'> & {
   readonly field: Partial<DosageBreak>;
   readonly index: number;
};

export const DosageBreakField = (props: DosageBreakFieldProps): JSX.Element => {
   const createFieldName = createStageFieldNameFactory(props.index);

   return (
      <StyledStagePanel>
         <StyledFlex direction={'row'} flexWrap={'wrap'} alignItems={'center'} gap={'6px'}>
            <Translate>{prescriptionTranslationKeys.extendedDosage.breakNoMedicine}</Translate>
            <DosagePeriodField
               register={props.register}
               watch={props.watch}
               trigger={props.trigger}
               invalid={false}
               amountName={createFieldName('duration.amount')}
               unitName={createFieldName('duration.unit')}
               amountDefaultValue={Number(props.field.duration?.amount ?? DEFAULTS.duration.amount)}
               unitDefaultValue={props.field.duration?.unit ?? DEFAULTS.duration.unit}
               testId={`breakDuration-${props.index}`}
            />
         </StyledFlex>
      </StyledStagePanel>
   );
};
